/* =============================================================
   ISD search overlay — behaviour for the header search panel.
   Markup lives in blocks/italisko-skonio-dezute-HEADER-V6-BG-MODE.liquid (opening/closing is the
   header's own openDrawer/closeDrawer); results are server-rendered by sections/predictive-search.liquid
   through the Section Rendering API, so the storefront visibility rule (snippets/isd-disc-kind.liquid)
   is applied once, in Liquid. This file only: debounces typing, fetches, injects, keeps the previous
   result visible (dimmed) while the next one loads, handles empty / error states, the clear button
   and arrow-key navigation. Enter submits the real form to /search?q=...&type=product.
   ============================================================= */
(function () {
  'use strict';
  if (window.__isdSearchBound) return;
  window.__isdSearchBound = true;

  var lang = (document.documentElement.lang || 'lt').slice(0, 2).toLowerCase();
  var COPY = {
    lt: { searching: 'Ieškoma…', error: 'Nepavyko įkelti paieškos rezultatų.', retry: 'Rodyti visus rezultatus' },
    lv: { searching: 'Meklē…', error: 'Neizdevās ielādēt meklēšanas rezultātus.', retry: 'Rādīt visus rezultātus' },
    en: { searching: 'Searching…', error: 'Could not load search results.', retry: 'Show all results' }
  };
  var T = COPY[lang] || COPY.en;
  var MIN_CHARS = 2;
  var DEBOUNCE = 170;

  function init() {
    var form = document.querySelector('[data-sk-search-form]');
    if (!form) return;
    var panel = form.closest('[data-sk-drawer="search"]') || document;
    var input = form.querySelector('[data-sk-search-input]');
    var clearBtn = form.querySelector('[data-sk-search-clear]');
    var home = panel.querySelector('[data-sk-search-home]');
    var out = panel.querySelector('[data-sk-search-results]');
    if (!input || !out) return;

    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var searchUrl = form.getAttribute('action') || '/search';
    var timer = null, ctrl = null, token = 0, cache = {}, cacheOrder = [];

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function allUrl(term) { return searchUrl + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last'; }
    function remember(key, html) {
      if (!cache[key]) cacheOrder.push(key);
      cache[key] = html;
      if (cacheOrder.length > 40) delete cache[cacheOrder.shift()];
    }
    function showHome() {
      token++;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      clearTimeout(timer);
      out.innerHTML = '';
      out.classList.remove('is-loading');
      out.removeAttribute('aria-busy');
      if (home) home.hidden = false;
    }
    function showResults(html) {
      if (home) home.hidden = true;
      out.innerHTML = html;
      out.classList.remove('is-loading');
      out.removeAttribute('aria-busy');
    }
    function showError(term) {
      showResults('<p class="isd-sx__state">' + esc(T.error) + ' <a href="' + esc(allUrl(term)) + '">' + esc(T.retry) + '</a></p>');
    }
    function run(term) {
      var key = term.toLowerCase();
      if (cache[key]) { token++; showResults(cache[key]); return; }
      var mine = ++token;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = 'AbortController' in window ? new AbortController() : null;
      if (home) home.hidden = true;
      if (out.querySelector('[data-isd-sx-results]')) {
        out.classList.add('is-loading');
        out.setAttribute('aria-busy', 'true');
      } else {
        out.innerHTML = '<p class="isd-sx__state">' + esc(T.searching) + '</p>';
      }
      var url = base + '?q=' + encodeURIComponent(term)
        + '&section_id=predictive-search'
        + '&resources%5Btype%5D=product,collection'
        + '&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each'
        + '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, { headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          if (mine !== token) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-isd-sx-results]');
          if (!el) throw new Error('no results markup');
          var markup = el.outerHTML;
          remember(key, markup);
          showResults(markup);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (mine !== token) return;
          showError(term);
        });
    }

    function onInput() {
      var term = input.value.trim();
      form.classList.toggle('has-value', input.value.length > 0);
      clearTimeout(timer);
      if (term.length < MIN_CHARS) { showHome(); return; }
      timer = setTimeout(function () { run(term); }, DEBOUNCE);
    }
    input.addEventListener('input', onInput);

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      form.classList.remove('has-value');
      showHome();
      input.focus();
    });

    /* Arrow keys: input -> first link -> ... ; ArrowUp from the first link returns to the field. */
    function links() {
      var scope = out.querySelector('a[href]') ? out : home;
      return scope ? [].slice.call(scope.querySelectorAll('a[href]')) : [];
    }
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var list = links();
      if (!list.length) return;
      var active = document.activeElement;
      var i = list.indexOf(active);
      if (active === input) {
        if (e.key === 'ArrowDown') { e.preventDefault(); list[0].focus(); }
        return;
      }
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') { if (i < list.length - 1) list[i + 1].focus(); }
      else if (i === 0) input.focus();
      else list[i - 1].focus();
    });

    /* A restored value (browser back / autofill) behaves like typing. */
    if (input.value.trim().length >= MIN_CHARS) onInput();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
